export const propFaqBooking = {
  faqEditor: {
    empty: "Ainda não há perguntas. Adicione a primeira para que o agente saiba como respondê-la.",
    learnedTooltip: "Resposta adicionada pelo autoaprendizado do anfitrião",
    learnedBadge: "Aprendida",
    removeAttachment: "Remover anexo",
    uploading: "Enviando…",
    attach: "Anexar",
    deleteTooltip: "Excluir",
    addQuestion: "Adicionar pergunta",
    qPlaceholder: "Pergunta · ex.: Tem estacionamento?",
    aPlaceholder: "Resposta · ex.: Sim, gratuito bem na frente.",
    errors: {
      fillBeforeAttach: "Insira a pergunta e a resposta antes de anexar arquivos.",
      saveBeforeAttach: "Salve primeiro para anexar arquivos.",
      uploadFailed: "Não foi possível enviar o arquivo.",
      deleteFailed: "Não foi possível excluir o arquivo.",
    },
  },
  faqSuggestions: {
    title: "Sugestões para aprender",
    intro: "O agente não conseguiu responder a estas perguntas e você respondeu ao hóspede. Revise, edite se necessário e salve para que o agente possa respondê-las sozinho de agora em diante.",
    askedLabel: "O hóspede perguntou",
    questionLabel: "Pergunta",
    questionPlaceholder: "Como você formularia a pergunta?",
    answerLabel: "Resposta do agente",
    answerPlaceholder: "Resposta que o agente dará",
    applyToOthers: "Aplicar também a outras unidades do anúncio:",
    dismiss: "Descartar",
    saveAsAnswer: "Salvar como resposta",
    errors: {
      saveFailed: "Não foi possível salvar.",
      dismissFailed: "Não foi possível descartar.",
    },
  },
  sourceNote: {
    title: "Ordem de prioridade das respostas do agente",
    infoAria: "Ver a ordem de prioridade das fontes do agente",
    lead: "Quando duas fontes dizem algo diferente sobre o mesmo detalhe, o agente segue esta ordem:",
    faqPre: "FAQs ",
    faqStrong: "por unidade individual",
    faqTag: "prevalece",
    configMain: "Configurações da acomodação",
    configMuted: "· horários, capacidade, serviços",
    kb: "Base de conhecimento",
  },
  bookingLinks: {
    title: "Como o hóspede reserva",
    subPre: "O agente envia seu link de ",
    subStrong: "Reservas Diretas",
    subPost: " e o hóspede reserva na web.",
    step1Pre: "Se ele mencionar uma ",
    step1Strong: "acomodação específica",
    step1Post: ", o agente envia o link direto dela.",
    step2Pre: "Se houver ",
    step2Strong1: "vários nessa área",
    step2Mid: ", ele ",
    step2Strong2: "lista cada um com seu link",
    step2Post: " mais o global.",
    step3Pre: "Se não conhecer a área, ele ",
    step3Strong: "sugere as áreas disponíveis",
    step3Post: " e pergunta onde ele gostaria de ficar.",
    globalLinkLabel: "Link global (todas as localidades)",
    copy: "Copiar",
    copied: "Copiado",
    noIdNote: "O link de reserva será gerado assim que sua conta tiver o identificador configurado.",
    toastCopied: "Link copiado",
    toastCopyFailed: "Não foi possível copiar",
  },
  bookingConfirm: {
    title: "Notificar nova reserva",
    subPre: "Quando uma reserva é confirmada, notificamos o hóspede automaticamente ",
    subStrong: "no WhatsApp",
    subPost: " com os detalhes da estadia.",
    toggleLabel: "Enviar a confirmação no WhatsApp",
    toggleHint: "Se você desativar isso, esta notificação não será enviada ao hóspede. Se a reserva vier de uma OTA, a OTA o notificará.",
    stateOn: "Sim, enviar",
    stateOff: "Não enviar",
    notEditablePre: "Por enquanto, o conteúdo desta mensagem ",
    notEditableStrong: "não pode ser editado",
    notEditablePost: ". Estamos mostrando uma prévia do que o hóspede recebe.",
    previewTag: "Prévia · o que o hóspede vê",
    online: "online",
    today: "Hoje",
    previewHint: "Atualiza conforme sua configuração",
    defaultListingName: "Acomodação",
    toastEnabled: "Notificação de reserva ativada",
    toastDisabled: "Notificação de reserva desativada",
    toastSaveFailed: "Não foi possível salvar a alteração",
    previewGuest: "Laura García",
    previewBody: "Olá *{guest}* 👋\n\nSua reserva em *{name}* está confirmada ✅\n\nCódigo da reserva: *6233Q1VC5*\nDatas: *05/06/2026* – *07/06/2026* 📅\n\nPor este WhatsApp você pode solicitar o link do seu check-in online e também receber as instruções de chegada.\nSe precisar de ajuda antes ou durante a estadia, fale com a gente por aqui 💬",
    previewCta: "🇪🇸 Para continuar com o check-in, toque no botão *Ok* ou digite *Ok*.",
  },
};
